(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ivoodoo-repair-handover"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('iv-repair-handover')) {
    customElements.define('iv-repair-handover', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        this.form = this.radios[0]?.form;
        this.error = this.querySelector('[role="alert"]');
        this.addEventListener('change', () => this.sync(), options);
        this.addEventListener('invalid', event => {
          event.preventDefault();
          this.validate();
        }, { ...options, capture: true });
        this.form?.addEventListener('submit', event => {
          if (!this.validate()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { ...options, capture: true });
        this.sync();
      }

      disconnectedCallback() { this.controller?.abort(); }

      get value() { return this.querySelector('input:checked')?.value || ''; }

      sync() {
        if (this.value) {
          this.error.hidden = true;
          this.radios.forEach(input => {
            input.removeAttribute('aria-invalid');
            input.removeAttribute('aria-describedby');
          });
        }
        this.querySelectorAll('[data-handover-detail]').forEach(detail => {
          detail.hidden = detail.dataset.handoverDetail !== this.value;
        });
      }

      reset() {
        this.querySelectorAll('input[type="radio"]').forEach(input => {
          input.checked = false;
          input.removeAttribute('aria-invalid');
          input.removeAttribute('aria-describedby');
        });
        this.querySelector('[role="alert"]').hidden = true;
        this.querySelectorAll('[data-handover-detail]').forEach(detail => { detail.hidden = true; });
      }

      validate() {
        if (this.value) return true;
        this.error.hidden = false;
        this.radios.forEach(input => {
          input.setAttribute('aria-invalid', 'true');
          input.setAttribute('aria-describedby', this.error.id);
        });
        this.radios[0]?.focus({ preventScroll: true });
        this.dispatchEvent(new CustomEvent('repair-handover:reveal', { bubbles: true }));
        return false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
